import React from "react";
import "../styles/LoadingScreen.css";
import logoSrc from "../assets/logo-aic.png";


// Cambia este src por tu logo real cuando lo tengas
// Ej: import logo from "../assets/ocesa-logo.png";
// const logoSrc = null;

const LoadingScreen = ({ text = "Cargando..." }) => {
  return (
    <div className="loading-screen">
      <div className="loading-card">
        {logoSrc ? (
          <img src={logoSrc} alt="Logo" className="loading-logo" />
        ) : (
          <div className="loading-logo fallback">OCESA</div>
        )}

        <p className="loading-text">{text}</p>

        <div className="loading-dots" aria-hidden>
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
